module.exports = __webpack_public_path__ + "img/limitTaiwan16-9.92f24c0d.jpg";